import { type GridColDef } from "@mui/x-data-grid";

import { type GlossaryTerm } from "./Glossary.data";

export const glossaryColumns: GridColDef<GlossaryTerm>[] = [
  {
    field: "term",
    headerName: "Term/Acronym",
    width: 300,
  },
  {
    field: "definition",
    headerName: "Definition",
    flex: 1,
    minWidth: 400,
  },
];
